import api from './api';

// Timesheets
export const getTimesheets = (params) => api.get('/v1/timesheets', { params });
export const getTimesheetById = (id) => api.get(`/v1/timesheets/${id}`);
// AKM POC §5.13 / §7.6 — o güne atanmış giriş-çıkış oturumları (kapı / okuyucu adlarıyla); puantaj satırı açılınca.
export const getTimesheetSessions = (userId, date) => api.get(`/v1/timesheets/${userId}/${date}/sessions`);
// T7 — "Eksik Kayıtlar": AnomaliesJson dolu günler. Filtreler: date[gte]/date[lte]/code[eq]/
// userFullName[like]/pageNumber/pageSize. code[eq] whitelist DIŞIysa backend 400 döner.
export const getAnomalies = (params) => api.get('/v1/timesheets/anomalies', { params });
// AKM POC §5.12 — açık hesaplama sorunları (engineError: kişinin puantajı hesaplanamadı;
// invalidOvertimePolicy: geçersiz fazla mesai politikası; overtimePolicyFrameworkMismatch: kişinin fazla mesai
// politikası yasal çerçevesiyle uyuşmuyor, yasal varsayılan eşikler kullanıldı). PaginatedList; en yeni önce.
export const getCalcIssues = (params) => api.get('/v1/timesheets/calc-issues', { params });
// T6: senkron hesaplamaz — kuyruğa yazar, { jobId } döner. Sonucu getCalcJob(id) ile anketleyin.
export const calculateTimesheets = (data) => api.post('/v1/timesheets/calculate', data);
// Poll sırasında ara hata toast'ı istenmiyor (bileşen zaten inline mesaj gösterecek) —
// skipErrorToast: interceptor bu isteğe özel toast basmaz, 2sn'lik döngü kendi kendini düzeltir.
export const getCalcJob = (id) => api.get(`/v1/timesheets/calculate-jobs/${id}`, { skipErrorToast: true });
// İnceleme Rec3 — yeni puantaj kurallarının yürürlük tarihi ({ effectiveFrom: "yyyy-MM-dd" | null }). Hesapla
// çekmecesinde yalnız bilgi amaçlı (seçilen başlangıç bu tarihten önceyse uyarı) — bu yüzden ara hata toast'ı
// istenmez: uç başarısızsa uyarı gösterilmez, hesaplama engellenmez.
export const getRulesEffectiveFrom = () => api.get('/v1/timesheets/rules-effective-from', { skipErrorToast: true });

// My Timesheet / Attendance
export const getMyTimesheet = (params) => api.get('/v1/my-timesheet', { params });
export const getMyAttendance = (params) => api.get('/v1/my-attendance', { params });

// Payroll Summary
export const getPayrollSummaries = (params) => api.get('/v1/ta/payroll-summary', { params });
export const getPayrollSummaryById = (id) => api.get(`/v1/ta/payroll-summary/${id}`);
export const calculatePayroll = (data) => api.post('/v1/ta/payroll-summary/calculate', data);
export const confirmPayroll = (id) => api.put(`/v1/ta/payroll-summary/${id}/confirm`);
export const lockPayroll = (id) => api.put(`/v1/ta/payroll-summary/${id}/lock`);

// TA Reports
export const getTardiness = (params) => api.get('/v1/ta/reports/tardiness', { params });
export const getAbsenteeism = (params) => api.get('/v1/ta/reports/absenteeism', { params });
export const getEarlyDeparture = (params) => api.get('/v1/ta/reports/early-departure', { params });
// AKM POC §7.4 — Eksik Çalışanlar (Devam Paneli'nden ve PDKS Raporları menüsünden).
export const getUndertime = (params) => api.get('/v1/ta/reports/undertime', { params });
export const getOvertimeReport = (params) => api.get('/v1/ta/reports/overtime', { params });
export const getExceptions = (params) => api.get('/v1/ta/reports/exceptions', { params });
export const getAttendanceCalendar = (params) => api.get('/v1/ta/reports/attendance-calendar', { params });
// AKM POC §7.2/§7.4 — Personel Devam Kartı kişi listesi, Vardiya Raporu, Plan–Gerçekleşen Sapma (TaReportQuery).
export const getAttendanceCards = (params) => api.get('/v1/ta/reports/attendance-cards', { params });
export const getShiftReport = (params) => api.get('/v1/ta/reports/shift-report', { params });
export const getPlanVsActual = (params) => api.get('/v1/ta/reports/plan-vs-actual', { params });

// Overtime Policies
export const getOvertimePolicies = (params) => api.get('/v1/ta/overtime-policies', { params });
export const getOvertimePolicyById = (id) => api.get(`/v1/ta/overtime-policies/${id}`);
export const createOvertimePolicy = (data) => api.post('/v1/ta/overtime-policies', data);
export const updateOvertimePolicy = (id, data) => api.put(`/v1/ta/overtime-policies/${id}`, data);
export const deleteOvertimePolicy = (id) => api.delete(`/v1/ta/overtime-policies/${id}`);
